export * from './FileFormatHtmlIcon';
export * from './FileFormatHtmlIcon16Light';
export * from './FileFormatHtmlIcon16Regular';
export * from './FileFormatHtmlIcon16Solid';
export * from './FileFormatHtmlIcon20Light';
export * from './FileFormatHtmlIcon20Regular';
export * from './FileFormatHtmlIcon20Solid';
export * from './FileFormatHtmlIcon24Regular';
export * from './FileFormatHtmlIcon24Solid';
export * from './FileFormatHtmlIcon32Regular';
export * from './FileFormatHtmlIcon64Regular';
